<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="AM ALLOCATION">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'roleConfiguration' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>back</v-btn
            >
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card-text
          class="pt-0 pr-1"
          :class="{
            'd-block py-3': $vuetify.breakpoint.xs,
            'd-flex align-center': $vuetify.breakpoint.smAndUp
          }"
        >
          <v-text-field
            :class="{
              'mr-0': $vuetify.breakpoint.xs,
              'mr-5': $vuetify.breakpoint.smAndUp
            }"
            v-model="search"
            @input="searchData"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width: 350px"
          />
          <v-btn
            elevation="1"
            v-on:click="addAM()"
            :class="{ 'mt-2': $vuetify.breakpoint.xs }"
            color="accent"
          >
            <v-icon left>mdi-plus</v-icon>
            Add
          </v-btn>
        </v-card-text>
        <v-divider class="my-0" />

        <v-data-table
          :footer-props="{
            'items-per-page-options': [5, 10, 20, 40]
          }"
          :items-per-page="10"
          :headers="headers"
          :items="formattedData"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              class="px-2 ml-1 ma-1"
              color="error"
              min-width="0"
              small
              v-if="!item.deletedAt"
              @click.prevent="deleteAcademicManager(item.userId)"
            >
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center"
              >No Data Available</v-card-subtitle
            >
          </template>
        </v-data-table>
      </material-card>
    </v-container>
  </div>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'

export default {
  name: 'ListAMAllocation',
  components: {
    MaterialCard
  },
  data () {
    return {
      search: '',
      amList: [],
      data: [],
      isLoading: false,
      page: 1,
      pageSize: 10,
      headers: [
        { text: 'Sr. No', value: 'srno' },
        { text: 'ZONE', value: 'zone' },
        { text: 'ZONAL MANAGER', value: 'zonalManager' },
        { text: 'ACADEMIC MANAGER', value: 'academicManager' },
        { text: 'ACTION', value: 'actions', sortable: false }
      ],
      formattedData: [],
      loadingComponent: null
    }
  },
  created () {
    this.getAMList()
  },
  methods: {
    addAM: async function () {
      this.$router.push({ name: 'addAM' })
    },
    getAMList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(
          `${constants.API_URL}/api/get-am-listing?search=${this.search}`
        )
        this.amList = response.data
        const formattedData = []

        for (const zone of this.amList) {
          const zm = zone.ams_zonalManagers.length
            ? zone.ams_zonalManagers[0].user
            : '-'
          for (const am of zone.ams_academicManagers) {
            const data = {
              srno: formattedData.length + 1,
              zone: zone.name,
              zonalManager: zm ? `${zm.firstName} ${zm.lastName}` : '-',
              academicManager: `${am.user.firstName} ${am.user.lastName}`,
              actions: null,
              amID: am.id,
              userId: am.userID
            }
            formattedData.push(data)
          }
        }

        this.formattedData = formattedData
        this.isLoading = false
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching AM list : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    searchData () {
      if (this.search) {
        this.page = 1
        this.getAMList()
      } else {
        this.getAMList()
      }
    },
    deleteAcademicManager: async function (amID) {
      let ref = this

      this.$dialog.warning({
        title: 'Delete User',
        text: 'Do you really want to <b>delete</b> this record?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async () => {
              try {
                ref.isLoading = true
                await http.delete(
                  `${constants.API_URL}/api/AM/remove-AM/${amID}`
                )
                ref.isLoading = false
                await ref.getAMList()

                return ref.$dialog.info({
                  title: 'Success',
                  text: 'Deleted academic manager successfully'
                })
              } catch (e) {
                ref.isLoading = false
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                return ref.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    }
  }
}
</script>
